"use client"
import { Box, Theme, useMediaQuery } from "@mui/material"
import type { FC } from "react"
import { sharedTheme } from "./theme/theme"
// Define the props for the component
interface MediaQueryComponentProps {
  aboveTheFold?: boolean
  children: React.ReactNode
  centerHorizontally?: boolean
  height?: string
  zIndex?: number
  fullWidth?: boolean
  fitContent?: boolean
}

export const Mobile: FC<MediaQueryComponentProps> = ({
  children,
  centerHorizontally,
  zIndex,
  fullWidth,
}) => (
  <Box
    sx={{
      display: { xs: "flex", md: "none" },
      justifyContent: centerHorizontally ? "center" : "unset",
      zIndex: zIndex,
      width: fullWidth ? "100%" : "unset",
    }}
  >
    {children}
  </Box>
)
export const Desktop: FC<MediaQueryComponentProps> = ({
  children,
  centerHorizontally,
  height,
  fitContent = false,
}) => (
  <Box
    sx={{
      display: { xs: "none", md: "flex" },
      justifyContent: centerHorizontally ? "center" : "unset",
      height: height,
      width: fitContent ? "fit-content" : "100%",
    }}
  >
    {children}
  </Box>
)

export const useIsDesktop = (): boolean =>
  useMediaQuery<Theme>(sharedTheme.breakpoints.up("md"))

export const DesktopOnly: FC<MediaQueryComponentProps> = ({
  children,
  centerHorizontally,
  height,
}) => (
  <Box
    sx={{
      display: { xs: "none", md: "flex", xl: "none" },
      justifyContent: centerHorizontally ? "center" : "unset",
      height: height,
    }}
  >
    {children}
  </Box>
)

export const LargeDesktop: FC<MediaQueryComponentProps> = ({
  children,
  centerHorizontally,
  height,
}) => (
  <Box
    sx={{
      display: { xs: "none", xl: "flex" },
      justifyContent: centerHorizontally ? "center" : "unset",
      height: height,
    }}
  >
    {children}
  </Box>
)

export const IEMediaQuery =
  "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)"

export const EdgeMediaQuery = "@supports (-ms-ime-align:auto)"
